import { Box } from '@factorialco/deprecated-design-system'
import { F0Alert } from '@factorialco/f0-react'

interface InfoComponentProps {
  messages: string[]
  color: 'destructive' | 'positive' | 'info'
}

const MAX_MESSAGES = 6

const variantMap = {
  destructive: 'critical',
  positive: 'positive',
  info: 'info',
} as const

export const InfoComponent = ({ messages, color }: InfoComponentProps) => {
  const title = messages[0] ?? ''
  const hiddenMessages = Math.max(messages.length - MAX_MESSAGES, 0)

  const descriptionItems = messages.filter((_, i) => i > 0 && i < MAX_MESSAGES)
  const bulletList = descriptionItems.map((item) => `• ${item}`).join('\n')
  const description = hiddenMessages > 0 ? `${bulletList}\n...` : bulletList

  return (
    <Box paddingTop="s12">
      <F0Alert variant={variantMap[color]} title={title} description={description} />
    </Box>
  )
}
